export const checkIsBot = (): boolean => {
  const botPattern =
    /bot|crawl|spider|slurp|duckduckgo|bing|google|yandex|baidu|sogou|facebook|pinterest|telegram|whatsapp|vkshare/i;

  const userAgent = navigator.userAgent;

  return botPattern.test(userAgent.toLowerCase());
};
